import type { PPProviderBehavior } from '../types';

export const myUsagePPBehavior: PPProviderBehavior = {
	label: 'MyUsage',
	cardDeviceDisplayName: 'EMV device',
	requiresPrepareTransaction: true,
	requiresPayorInformation: false,
	cardPrepareAutoStart: true,
	buildPrepareCheckRequest(ctx) {
		return {
			accountsToPay: ctx.cartItems.map((item) => ({
				accountNumber: item.item.itemNumber,
				amount: item.amountToPay,
			})),
			paymentType: 'ECHECK',
			location: ctx.kioskLocation,
			totalAmount: ctx.cartTotalAmount,
			payorInfo: ctx.payorInformation,
		};
	},
	buildPrepareCardRequest(ctx) {
		return {
			accountsToPay: ctx.cartItems.map((item) => ({
				accountNumber: item.item.itemNumber,
				amount: item.amountToPay,
			})),
			paymentType: 'CREDIT',
			location: ctx.kioskLocation,
			totalAmount: ctx.cartTotalAmount,
			payorInfo: ctx.payorInformation,
		};
	},
	getReceiptInvoiceNumber(item, _cartId, obscure) {
		return obscure ? (item.obscuredItemNumber ?? item.itemNumber) : item.itemNumber;
	},
	getTestPanelConfig() {
		return { show: true, altText: 'MyUsage' };
	},
};
